export default __webpack_public_path__ + "static/media/bb_guess_4.70378b4c.png";